/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : AUTH ACCEPT AGREEMENT COMPLETE : STYLES --------------- ++++++++++ */
export default theme => ({
    acceptagreement:{
        '& .copy':{
            height: '100%',
            maxWidth: `${pxToEm(460)} !important`,
            '& .bodycopy':{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-evenly',
            },
            '& h1': {
                fontSize: pxToEm(32),
                fontWeight: '500',
                marginBottom: pxToEm(20)
            },
            '& .agreementcopy': {
                textAlign: 'left'
            }
        },
        '& .group':{
            height: 'fit-content',
            maxWidth: pxToEm(438)
        },
        '& .ctas':{
            width: '100%',
            '& button': {
                width: '100%'
            }
        }
    }
});
